import { isNil } from "lodash-es";
import { ReactNode, createContext, useContext, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useComplexState } from "use-complex-state";
import { ProcesssReportReducer } from "../reducers/ProcesssDataReportReducer";

const ProcesssReportContext = createContext({
	state: ProcesssReportReducer.getInitialState(),
	actions: ProcesssReportReducer.actions,
});

export const useProcesssReportContext = () => useContext(ProcesssReportContext);

export const ProcesssReportProvider = ({
	children,
}: {
	children: ReactNode;
}) => {
	const { shiftId: shiftIdParam } = useParams();

	const [state, actions] = useComplexState({
		initialState: ProcesssReportReducer.getInitialState(),
		reducers: ProcesssReportReducer.caseReducers,
	});
	useEffect(() => {
		const shiftId = Number(shiftIdParam);
		if (isNil(shiftIdParam) || isNaN(shiftId)) {
			actions.setShiftId(null);
		} else {
			actions.setShiftId(shiftId);
		}
	}, [shiftIdParam]);
	return (
		<ProcesssReportContext.Provider value={{ state, actions }}>
			{children}
		</ProcesssReportContext.Provider>
	);
};
